import { create } from 'zustand';

type NotifState = {
  count: number;
  setCount: (n: number) => void;
};

export const useNotifStore = create<NotifState>((set) => ({
  count: 0,
  setCount: (count) => set({ count }),
}));
